import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {
  
  @Input() headerstring;
  headerStringValue:string
  constructor() { }

  ngOnInit(): void {
    this.headerStringValue = this.headerstring
  }

}
